export const uk = {
    clicks: 'Всего кликов',
    cost: 'Общий расход',
    ctr: 'средний CTR',
    shows: 'Всего показов'
};
